const Data = [
 {
   "id": 1,
   "peopleid": 1,
   "title": "Beck's Chopping Board",
   "location": "Roma",
   "desc": "Beck's chopping board can provide an array of catering options including Gourmet, Home Style, Country Cuisines, Finger Food, Corporate Lunches and much more. \n\nWe take pride in producing quality food from our kitchen to you.",
   "website": "https://www.facebook.com/beckschoppingboard/",
   "imagename": "QLD-1",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 2,
   "peopleid": 2,
   "title": "Oodies Cafe",
   "location": "Bundaberg",
   "desc": "At Oodies Cafe our goal is to provide you with a selection of fresh house-made goodies to suit your occasion.",
   "website": "https://www.oodies.com.au/wp-content/cache/all/index.html",
   "imagename": "QLD-2",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 3,
   "peopleid": 3,
   "title": "Fresh Fix Cafe",
   "location": "Gladstone",
   "desc": "Purpose of our cafe is to provide Gladstone with a modern rustic environment.\n\nServing fresh healthy food options, combined with quality beverages.",
   "website": "https://www.facebook.com/freshfixcafegladstone/",
   "imagename": "QLD-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 4,
   "peopleid": 4,
   "title": "Urban Paddock",
   "location": "Dalby",
   "desc": "Urban Paddock, set in historic Quambi House in Dalby, is a family-friendly café offering all-day dining, children’s menu & playground.",
   "website": "https://www.facebook.com/urbanpaddockcafe",
   "imagename": "QLD-4",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 5,
   "peopleid": 5,
   "title": "Cafe by Farmer and Sun",
   "location": "Gympie",
   "desc": "Fresh, clean, healthy food, from local farms to your plate. \n\nWe offer the best the region has to offer, in both our marketplace and our cafe.",
   "website": "https://www.farmerandsun.com.au/",
   "imagename": "QLD-5",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 6,
   "peopleid": 6,
   "title": "Pump 123",
   "location": "Toowoomba",
   "desc": "If ‘Coffee & Cake’ is the preference, then our sweets cabinet is for you. \n\nWe want our customers to have a warm & friendly experience when visiting PUMP and at the same time enjoy tasty food at a reasonable price.",
   "website": "https://www.facebook.com/pumpcafestoowoomba/",
   "imagename": "QLD-6",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 7,
   "peopleid": 7,
   "title": "Warwick’s Gardens Galore",
   "location": "Warwick",
   "desc": "From its humble beginnings, Warwick's Gardens Galore has grown rapidly to become one of the most exciting venues for foodies and green thumbs of all ages.\n\nNestled amongst the plants, the cafe/restaurant exudes a relaxed and peaceful ambience making it a local favourite and is the ideal place to catch up with friends and family.",
   "website": "https://www.facebook.com/gardensgalorew/",
   "imagename": "QLD-7",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 8,
   "peopleid": 8,
   "title": "Cafe Sisily",
   "location": "Golden Beach",
   "desc": "Bringing a taste of Sicily to Golden Beach with authentic sicilian pastries, coffees and legendary cannoli!",
   "website": "https://www.facebook.com/cafesisily/",
   "imagename": "QLD-8",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 9,
   "peopleid": 9,
   "title": "The Dispensary",
   "location": "Mackay",
   "desc": "Whether you’re after a morning coffee, breakfast, long lunch or delicious dinner, we’ve got you covered. \n\nEstablished in 2013, THE DISPENSARY would not be out of place in downtown Manhattan or inner-city Melbourne.",
   "website": "https://thedispensarymackay.com.au/",
   "imagename": "QLD-9",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 10,
   "peopleid": 10,
   "title": "Coffee Society",
   "location": "Rockhampton",
   "desc": "Coffee Society is the place to come for smooth coffee, rich but fresh breakfast & lunch options and one of a kind cakes made by 'Hey Sugar.",
   "website": "https://www.facebook.com/coffeesocietyrockhampton/",
   "imagename": "QLD-10",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 11,
   "peopleid": 11,
   "title": "Candy Café",
   "location": "Cairns",
   "desc": "Located in the heart of Cairns City, Candy Cafe provides convenience and unforgettable service. \n\nCandy Cafe has been serving great coffee, breakfast classics and deliciously interesting lunches from locally sourced produce since 2011.",
   "website": "http://www.candycafe.com.au/",
   "imagename": "QLD-11",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 12,
   "peopleid": 12,
   "title": "Rafter & Rose",
   "location": "Ipswich",
   "desc": "A unique interior and welcoming atmosphere have helped cement Rafter & Rose as Ipswich’s Best Cafe.",
   "website": "https://www.facebook.com/rafterandrose/",
   "imagename": "QLD-12",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 13,
   "peopleid": 13,
   "title": "The Gift Shop Food & Drink",
   "location": "Upper Mt Gravatt",
   "desc": "Coffee, food, drinks, good times.",
   "website": "https://www.thegiftshopfd.com/",
   "imagename": "QLD-13",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 14,
   "peopleid": 14,
   "title": "Otto’s at Warrina",
   "location": "Warrina",
   "desc": "The kitchen is the heart of our household and we enjoy nothing more than preparing good food to share with family and friends. \n\nThrough Otto’s Market, we want to extend this passion and share it with out local community, Townsville and beyond.",
   "website": "https://ottosmarket.com.au/",
   "imagename": "QLD-14",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 15,
   "peopleid": 15,
   "title": "Helena’s Espresso",
   "location": "Nerang",
   "desc": "Specialty Coffee House & Eatery - Encouraging a community atmosphere where the community can interact in a casual and relaxing environment",
   "website": "https://www.facebook.com/Helenas.Espresso/",
   "imagename": "QLD-15",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 16,
   "peopleid": 16,
   "title": "The Little Larder",
   "location": "Stanthorpe",
   "desc": "Inspired by our favourite city New York, but aimed at satisfying our modern Australian palate, we have created a breakfast, lunch and dinner menu showcasing classic dishes using local produce.",
   "website": "https://www.littlelarderstanthorpe.com.au/",
   "imagename": "QLD-16",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 17,
   "peopleid": 17,
   "title": "Salt",
   "location": "Fraser Coast",
   "desc": "You will find us on the beachfront side of Oceans Resort & Spa along the Esplanade at Urangan … down at the relaxing end of town. \n\nWhen you need to unwind Salt Cafe is definitely the place to do it … a few minutes enjoying the view and a great cup of coffee and you’ll be as relaxed as we are.",
   "website": "https://saltcafe.com.au/",
   "imagename": "QLD-17",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 18,
   "peopleid": 18,
   "title": "Laidley Florist and Tea Room",
   "location": "Laidley",
   "desc": "Situated in the historic Giesemann’s Building in the picturesque country town of Laidley, the heart of Queensland’s ‘Salad Bowl’, Rustique Rose Florist & Tea Room combines a love of flowers, history and atmosphere, and has become an iconic Lockyer Valley attraction for lovers of old-world charm.",
   "website": "https://laidleyfloristandtearoom.com.au/",
   "imagename": "QLD-18",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 19,
   "peopleid": 19,
   "title": "Downtown Cafe",
   "location": "Chinchilla",
   "desc": "Creating fresh and healthy food is our main objective. What brings customers back is quality and exceptional customer service so we added this our service. \n\nOur food and drinks will surely not disappointed you.",
   "website": "https://www.thedowntowncafe.com.au/",
   "imagename": "QLD-19",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 20,
   "peopleid": 20,
   "title": "The Coffee Bar 4605 - Murgon",
   "location": "South Burnett",
   "desc": "We are a quaint little coffee shop located in the small rural community of Murgon, Queensland. \n\nKnown for our barista made Miko coffee, excellent customer service, simple food served & presented well. Eclectic decor with a country twist.",
   "website": "https://www.facebook.com/The-Coffee-Bar-4605-1492523280795791/",
   "imagename": "QLD-20",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 21,
   "peopleid": 21,
   "title": "Extraction Artisan Coffee",
   "location": "Slacks Creek",
   "desc": "Extraction is all about encouraging a love and appreciation of coffee. \n\nExtract yourself from the daily grind and we'll bring joy into your day.\n",
   "website": "https://extractionartisancoffee.com.au/",
   "imagename": "QLD-21",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 22,
   "peopleid": 22,
   "title": "Mug Shots Espresso",
   "location": "Sandgate",
   "desc": "We pride ourselves on providing fair trade tea and coffee, quickly and how you like it. \n\nWe work with local suppliers and bakeries to source the freshest, highest quality muffins, sandwiches, cakes and slices.",
   "website": "https://mugshotsespresso.com.au/",
   "imagename": "QLD-22",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 23,
   "peopleid": 23,
   "title": "Petrichor & Co",
   "location": "Hamilton",
   "desc": "Inspired from the exotic flavours of Colombia and Latin America we have put a lot of love and effort into creating a menu of dishes that go above and beyond the typical café fare, our food tastes great featuring seasonal produce including delicious, nutritious, gluten-free and vegan dishes.",
   "website": "https://petrichorandco.com/",
   "imagename": "QLD-23",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 24,
   "peopleid": 24,
   "title": "Arte & Gusto",
   "location": "Graceville",
   "desc": "Come and enjoy the beautiful flavours of our modern Australian menu, made from fresh ingredients sourced locally. \n\nOur cool, casual vibe is perfect for any occasion, our tapas are a must and we are licensed too.",
   "website": "https://www.arteandgusto.com.au/",
   "imagename": "QLD-24",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 25,
   "peopleid": 25,
   "title": "The Coffee Patch on Hasking",
   "location": "Caboolture",
   "desc": "The Coffee Patch on Hasking is the hidden jewel of Caboolture. \n\nWe take great pride in serving food that touches your soul and coffee that warms your heart.",
   "website": "https://www.facebook.com/The-Coffee-Patch-on-Hasking-113200186772789/",
   "imagename": "GEN-1",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 26,
   "peopleid": 26,
   "title": "Sea, Salt & Vine",
   "location": "Scarborough",
   "desc": "Sea Salt and Vine is a family-owned business run by Doug and Sue Galvin and daughter Georgia.\n\nOn top of producing a good range of meals for breakfast and lunch and great coffees, we arguably have one of the best locations on the Peninsula – the view looking north across to the Glasshouse Mountains is simply amazing.",
   "website": "http://seasaltandvine.com.au/",
   "imagename": "QLD-26",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 27,
   "peopleid": 27,
   "title": "Rabbit Hole Cafe",
   "location": "Wynnum",
   "desc": "The Rabbit Hole Café is located in the delightful suburbs of Seven Hills & Wynnum on the bayside. \n\nThis is a special place for all to enjoy & experience suburban home-style cooking, friendly service & amazing coffee.",
   "website": "https://www.rabbithole.cafe/",
   "imagename": "QLD-27",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 28,
   "peopleid": 28,
   "title": "The Smokin' Goat",
   "location": "Tingalpa",
   "desc": "Located in the heart of Tingalpa, we offer an extensive breakfast, lunch and dinner menu alongside premium specialty espresso with an emphasis on friendly service, a laid-back atmosphere and delicious food. \n\nWe are also GF, Vego and pet friendly!",
   "website": "https://www.facebook.com/the.smokin.goat.tingalpa/",
   "imagename": "QLD-28",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 29,
   "peopleid": 29,
   "title": "BLVD Cafe",
   "location": "North Lakes",
   "desc": "Located in North Lakes, BLVD Bar & Cafe is a purveyor of fine food and coffee.\n\nWe LOVE making new connections and sharing the experience that is BLVD and we LOVE putting a SMILE on your dial.",
   "website": "http://blvdbarandcafe.com/",
   "imagename": "QLD-29",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 30,
   "peopleid": 30,
   "title": "Blue Tongue Pantry",
   "location": "Thorneside",
   "desc": "Brunch, Great Coffee and Artisan Pantry Staples - Locally Sourced and Seasonal Ingredients",
   "website": "https://www.facebook.com/bluetonguepantry/",
   "imagename": "QLD-30",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 31,
   "peopleid": 31,
   "title": "Screamin' Beans",
   "location": "Springfield",
   "desc": "Visit Screamin’ Beans in Springfield, where we believe food is not just about feeding your body, it’s about feeding your soul. \n\nIt’s time to refresh, rejuvenate, be greeted with a friendly smile and treated to delicious food.",
   "website": "https://www.screaminbeans.com.au/",
   "imagename": "QLD-31",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 }
]

export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js